import CustomTabs from "components/Shared/CustomTabs";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import { useSearchParams } from "react-router-dom";
import { useRegionDetailContext } from "contexts/LocationContexts/RegionDetailContext";
import DistrictTab from "./DistrictTab";
import MunicipalityTab from "./MunicipalityTab";
import BranchesTab from "./BranchesTab";
import CustomTabPanel from "components/Shared/CustomTabPanel";

export const RegionDetailTabs = () => {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "branches";
  const { regionDetail, loadingDetail } = useRegionDetailContext();

  const tabs = [
    {
      label: "Linked District",
      value: "district",
    },
    {
      label: "Linked Municipalities",
      value: "municipalities",
    },
    {
      label: "Linked Branches",
      value: "branches",
    },
  ];
  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {!loadingDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="district">
            <DistrictTab regionDetail={regionDetail} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="municipalities">
            <MunicipalityTab regionDetail={regionDetail} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="branches">
            <BranchesTab regionDetail={regionDetail} />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default RegionDetailTabs;
